import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const ReferralProgramView = React.lazy(() => import("./ReferralProgram.view"));

const ReferralProgramLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <ReferralProgramView />
  </React.Suspense>
);

export default () => <ReferralProgramLoadable />;
